import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import './App.css'
import About from "./Pages/About";
import Book from "./Pages/Book";
import Gallery from "./Pages/Gallery";
import Pricing from "./Pages/Pricing";
import QA from "./Pages/QA";
import Privacy from "./Pages/Privacy";
import Cookies from "./Pages/Cookies";
import CGV from "./Pages/CGV";
import PageLoading from "./Components/PageLoading";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Hide loading screen after animation completes
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {loading && <PageLoading />}
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/book" element={<Book />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/qa" element={<QA />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/cookies" element={<Cookies />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
